<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
      lg="4"
      v-for="(user, index) in attendees(true)"
      :key="index"
    >
      <action-items-card
        :action-items="
          checkin.pastActionItems.filter(x => x.assignedTo.id == user.id)
        "
        :user="user"
        allow-completion
      >
      </action-items-card>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      lg="4"
      v-for="(user, index) in attendees(false)"
      :key="index"
    >
      <action-items-card
        :action-items="
          checkin.actionItems.filter(x => x.assignedTo.id == user.id)
        "
        :user="user"
      >
      </action-items-card>
    </v-col>
  </v-row>
</template>

<script>
import ActionItemsCard from "@/components/checkin/ActionItemsCard";
import { mapGetters } from "vuex";
export default {
  name: "ActionItems",
  components: {
    ActionItemsCard
  },
  computed: {
    attendees() {
      return isPast => {
        let userIds = (isPast
          ? this.checkin.pastActionItems
          : this.checkin.actionItems
        ).map(x => x.assignedTo.id);
        return this.checkin.attendees.filter(x => userIds.indexOf(x.id) >= 0);
      };
    },
    isComplete() {
      return this.checkin.completeDate != null;
    },
    ...mapGetters({ checkin: "checkin/checkin" })
  },
  methods: {}
};
</script>
